import { useState, useContext } from 'react';
import AccessCodeContext from '../context/AccessCodeContext';

const AccessCodeVerification = () => {
  const { verifyCode, error } = useContext(AccessCodeContext);
  const [code, setCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setFormError('Please enter an access code');
      return;
    }
    
    setIsSubmitting(true);
    setFormError('');
    
    try {
      const result = await verifyCode(code);
      
      if (!result.success) {
        setFormError(result.error || 'Invalid access code');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setFormError('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-90">
      <div className="neumorph p-8 rounded-lg w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Access Required</h1>
        
        <p className="text-gray-600 mb-6 text-center">
          Please enter the access code to continue to the website.
        </p>
        
        {(formError || error) && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {formError || error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="code" className="block text-gray-700 mb-2">Access Code</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="neumorph-inset w-full px-4 py-2 rounded-lg focus:outline-none"
              placeholder="Enter your access code"
              autoComplete="off"
            />
          </div>
          
          <button
            type="submit"
            className="neumorph-btn w-full py-3 font-semibold"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Verifying...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccessCodeVerification;
